<template>
  <v-app id="inspire">
    <Sidebar class="d-print-none" v-if="isSecuredPaged" />
    <Header class="d-print-none" @load="loadedCenters" v-if="isSecuredPaged" />
    <v-main v-if="!isSecuredPaged || headerLoaded">
      <message-component class="d-print-none"></message-component>
      <router-view :key="$route.fullPath"></router-view>
    </v-main>
    <div v-if="appVersion" class="d-print-none text-caption font-weight-light">
      Version {{ appVersion }} - {{ appRevisionDate }}
    </div>
  </v-app>
</template>

<script lang="ts">
import { mapActions } from 'vuex';
import MessageComponent from '@/components/common/MessageComponent.vue';
import layouts from '@/components/layout/';
import Vue from 'vue';

export default Vue.extend({
  components: {
    ...layouts,
    MessageComponent,
  },
  props: {
    source: String,
  },
  data: () => ({
    headerLoaded: false,
    dialog: false,
    env: process.env.NODE_ENV,
    baseUrl: process.env.VUE_APP_BASE_URL,
    title: process.env.VUE_APP_TITLE,
    appVersion: process.env.GIT_VERSION,
    appRevisionDate: process.env.GIT_LASTCOMMITDATETIME,
  }),
  computed: {
    isSecuredPaged() {
      if (this.$route.meta) {
        if (
          this.$route.meta.requiresAuth ||
          (this.$route.meta.authorize && this.$route.meta.authorize.length > 0)
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
  methods: {
    ...mapActions('navigation', ['appLoading']),
    loadedCenters() {
      // console.log(centers);
      this.headerLoaded = true;
    },
  },
  created() {
    // axios Interceptors are now initialized in main.ts
  },
});
</script>

<style>
@media print {
  .v-main {
    padding: 0 !important;
  }
}
</style>
